"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Text = exports.TEXT_TAGS = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _reactToString = _interopRequireDefault(require("react-to-string"));
var _react = _interopRequireWildcard(require("react"));
var _Button = require("../Buttons/Button");
var _debounce = require("../utils/debounce");
var _useResizeObserver = require("../utils/useResizeObserver");
var _useUniqueId = require("../utils/useUniqueId");
var _Text = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Text.css") : void 0);
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _getOwnPropertySymbols.default === "function") for (var i = 0, p = (0, _getOwnPropertySymbols.default)(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var CSS_BLOCK = 'sapcnqr-text';
var TEXT_TAGS = exports.TEXT_TAGS = ['span', 'p', 'b', 'strong', 'i', 'em', 'pre', 'code', 'div'];
/**
 * The **Text** component can be used for embedding long
 * text, that needs themed styles
 * and formatting and/or truncation,
 * into your application.
 */
var Text = exports.Text = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var allowHyphenation = props.allowHyphenation,
    children = props.children,
    className = props.className,
    expanded = props.expanded,
    id = props.id,
    maxLines = props.maxLines,
    showMore = props.showMore,
    _props$tag = props.tag,
    tag = _props$tag === void 0 ? 'span' : _props$tag,
    useLabelStyles = props.useLabelStyles,
    otherProps = __rest(props, ["allowHyphenation", "children", "className", "expanded", "id", "maxLines", "showMore", "tag", "useLabelStyles"]);
  var _useState = (0, _react.useState)(typeof maxLines === 'number' && maxLines > 0),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    hasMaxLines = _useState2[0],
    setHasMaxLines = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    isClamped = _useState4[0],
    setIsClamped = _useState4[1];
  var _useState5 = (0, _react.useState)(!!expanded),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    isExpanded = _useState6[0],
    setIsExpanded = _useState6[1];
  var classnames = _bind.default.bind(_Text.default);
  var textRef = (0, _react.useRef)(null);
  var mergedRef = (0, _reactMergeRefs.default)([ref, textRef]);
  var textId = (0, _useUniqueId.useUniqueId)();
  var _ref = showMore || {},
    showMoreLabel = _ref.showMoreLabel,
    showLessLabel = _ref.showLessLabel,
    onShowMoreClick = _ref.onClick,
    buttonProps = _ref.buttonProps,
    containerProps = _ref.containerProps;
  var updateClamping = function updateClamping() {
    var _ref2 = textRef.current || {},
      offsetHeight = _ref2.offsetHeight,
      scrollHeight = _ref2.scrollHeight;
    var newIsClamping = scrollHeight > offsetHeight;
    setIsClamped(newIsClamping);
  };
  var onResize = (0, _debounce.debounce)(function () {
    if (isExpanded) return;
    updateClamping();
  });
  (0, _useResizeObserver.useResizeObserver)({
    targetRef: textRef,
    onResize: onResize
  });
  (0, _react.useEffect)(function () {
    if (!isExpanded) {
      updateClamping();
    }
  }, [isExpanded]);
  (0, _react.useEffect)(function () {
    var newValue = typeof maxLines === 'number' && maxLines > 0;
    setHasMaxLines(newValue);
  }, [maxLines]);
  var maxLineStyle;
  if (hasMaxLines && !isExpanded) {
    maxLineStyle = {
      // @ts-expect-error maxLines
      WebkitLineClamp: "".concat(parseInt(maxLines, 10))
    };
  }
  var handleShowMoreClick = function handleShowMoreClick() {
    var newIsExpanded = !isExpanded;
    setIsExpanded(newIsExpanded);
    onShowMoreClick === null || onShowMoreClick === void 0 ? void 0 : onShowMoreClick(newIsExpanded);
  };
  var classes = classnames(className, CSS_BLOCK, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "--max-lines"), hasMaxLines), "".concat(CSS_BLOCK, "--hyphenation"), allowHyphenation), "".concat(CSS_BLOCK, "--label"), useLabelStyles));
  var containerClasses = classnames("".concat(CSS_BLOCK, "__container"), containerProps === null || containerProps === void 0 ? void 0 : containerProps.className);
  var ElementToRender = TEXT_TAGS.indexOf(tag) !== -1 ? tag : 'span';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(ElementToRender, (0, _assign.default)({
    title: isClamped && !isExpanded ? (0, _reactToString.default)(children) : undefined
  }, otherProps, {
    id: hasMaxLines && showMore && !id ? textId : id,
    ref: mergedRef,
    className: classes,
    style: (0, _assign.default)((0, _assign.default)({}, otherProps === null || otherProps === void 0 ? void 0 : otherProps.style), maxLineStyle)
  }), children), hasMaxLines && showMore && (isClamped || isExpanded) && ( /*#__PURE__*/_react.default.createElement("div", (0, _assign.default)({}, containerProps, {
    className: containerClasses
  }), /*#__PURE__*/_react.default.createElement(_Button.Button, (0, _assign.default)({
    compact: true,
    type: "link"
  }, buttonProps, {
    "aria-controls": !id ? textId : id,
    "aria-expanded": isExpanded,
    onClick: handleShowMoreClick
  }), isExpanded ? showLessLabel : showMoreLabel))));
});
Text.displayName = 'Text';
var _default = exports.default = Text;